// Google Image Search API integration
const API_KEY = "AIzaSyDM66BXDGxyI4cVJskM-lgT7L15FmGCPRc";
const CX = "83198ed28b149434f";

export const googleImageSearch = async (query, numResults = 10) => {
  try {
    const url = "https://www.googleapis.com/customsearch/v1";
    const params = new URLSearchParams({
      key: API_KEY,
      cx: CX,
      q: query,
      searchType: "image",
      num: Math.min(numResults, 10).toString()
    });
    
    const response = await fetch(`${url}?${params}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }
    
    const data = await response.json();
    
    const results = [];
    for (const item of data.items || []) {
      results.push({
        title: item.title,
        link: item.link,
        thumbnail: item.image?.thumbnailLink,
        context: item.image?.contextLink
      });
    }
    
    return results;
  } catch (error) {
    console.error('Google Image Search error:', error);
    throw error;
  }
};

export default googleImageSearch;